import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
const KEY = "lss_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const addItem = (product, variant = null) => {
    setItems((prev) => {
      const key = `${product.id}::${JSON.stringify(variant || {})}`;
      const found = prev.find((i) => i._key === key);
      if (found) return prev.map((i) => (i._key === key ? { ...i, quantity: i.quantity + 1 } : i));
      return [...prev, { _key: key, product_id: product.id, name: product.name, price: product.price, image: product.images?.[0], quantity: 1, variant }];
    });
    setOpen(true);
  };

  const removeItem = (key) => setItems((prev) => prev.filter((i) => i._key !== key));
  const updateQty = (key, qty) => setItems((prev) => prev.map((i) => (i._key === key ? { ...i, quantity: Math.max(1, qty) } : i)));
  const clear = () => setItems([]);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  const value = useMemo(
    () => ({ items, addItem, removeItem, updateQty, clear, total, count, open, setOpen }),
    [items, total, count, open]
  );

  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
